export const AIRPORTS = "Airports";
